import { useQuery } from 'react-query';

import type { CurrencyCode } from '@/finance/interfaces';
import { trpcClient } from '@/trpc/client';

export const useExchangeRate = (
  baseCurrency: CurrencyCode | undefined,
  compareCurrency: CurrencyCode | undefined
) => {
  return useQuery(
    ['currencyExchangeRate', baseCurrency, compareCurrency],
    async () => {
      try {
        if (
          !baseCurrency ||
          !compareCurrency ||
          baseCurrency === compareCurrency
        ) {
          return undefined;
        }

        const rates = await trpcClient.forex.rates.query({
          base: baseCurrency,
          comparison: compareCurrency,
        });

        return rates.result;
      } catch (e) {
        console.error(e);
        return undefined;
      }
    },
    {
      staleTime: 60 * 60e3,
      // When this is false, we would return undefined anyway
      enabled: Boolean(compareCurrency && baseCurrency !== compareCurrency),
    }
  );
};
